<template>
  <v-form>
    <v-container>
      <div style="height: 10px;"></div>
      <div style="font-size: 20px;">{{ storeName }}</div>
      <div style="height: 30px;"></div>

      <v-card>
        <v-container>
          <v-card-title>店舗在庫登録</v-card-title>

          <div style="height: 30px;"></div>

          <v-layout row wrap align-center>
            <v-flex xs12>
              <v-text-field
                v-model="search"
                append-icon="search"
                label="商品名検索"
                single-line
                hide-details
                clearable
              ></v-text-field>
            </v-flex>

            <div style="height: 35px;"></div>

            <v-data-table
              :headers="headers"
              :items="storeItems"
              hide-actions
              class="elevation-1"
              style="width: 100%;    margin: 15px 0 0;"
              :search="search"
              :customFilter="customFilter"
              :no-data-text="$t('noTableDataAvailable')"
            >
              <template v-slot:items="props">
                <tr>
                  <td class="text-xs-left px-2">{{ props.item.itemCategoryName }}</td>
                  <td class="text-xs-left px-2">{{ props.item.itemName }}</td>
                  <td class="text-xs-center px-2">{{ props.item.janCode }}</td>
                  <td class="text-xs-left px-2">{{ props.item.createdAt }}</td>
                  <td class="text-xs-left px-2">{{ props.item.updatedAt }}</td>                  
                  <td class="text-xs-right px-2" >
                    <input
                      type="number"
                      categoryName="itemNum[]"
                      v-model="props.item.stockQuantity"
                      min="0"
                      class="column-input"
                      style="width: 100% !important;"
                      @change="editItem(props.item)"
                    />
                  </td>
                  <td class="text-xs-right px-2">{{ props.item.standardStock }}</td>
                </tr>
              </template>
            </v-data-table>
          </v-layout>
        </v-container>
      </v-card>

      <div style="height: 35px;"></div>

      <v-layout row wrap>
        <v-flex xs12 sm12 v-if="storeItems.length > 0">
          <v-btn  
            block
            color="warning"
            dark
            @click="updateStoreStockQuantity()"
          >確定する</v-btn>
        </v-flex>

        <div style="height: 35px;"></div>

        <v-flex xs12 sm12>
          <v-btn block color="#4C728A" dark :to="{ name: 'sales/new-user-menu' }">
            <v-icon dark left>arrow_back</v-icon>
            {{ $t('back-btn') }}
          </v-btn>
        </v-flex>
      </v-layout>
    </v-container>
  </v-form>
</template>

<script>
import ServerApiCallService from '@/services/ServerApiCallService.js'

export default {
  created() {
    console.log('created')
    
    ServerApiCallService.setAppJs(this.$parent.$parent.$parent)
    this.storeCode = this.$route.params.storeCode
    this.storeName = this.$route.params.storeName

    // 점포의 상품정보 가져오기
  this.getStoreStockQuantity()
  },
  methods: {
    customFilter(items, search) {
      if (!search) {
        return items
      } else {
        let filteringItems = items.filter(function(value) {
          if (value.itemName.includes(search)) {
            return true
          } else {
            return false
          }
        })
        return filteringItems
      }
    },
    getStoreStockQuantity() {
      console.log("getStoreStockQuantity");

      let request = {storeCode: this.storeCode}
      ServerApiCallService.getStoreStockQuantity(request)
        .then(response => {
          this.storeItems = response.data.storeItems

          // カテゴリの表示順
          this.storeItems.sort(function(a, b) {
            if (a.itemCategoryId > b.itemCategoryId) return 1
            if (a.itemCategoryId < b.itemCategoryId) return -1
            // a must be equal to b
            return 0
          })
          
          // 데이타 변형
          this.storeItems.forEach(function(row) {            
            // 생성날짜는 초까지 보이기
            if (row.createdAt != null) {
              row.createdAt = row.createdAt.substr(0, 16)
            }

            // 변경날짜는 초까지 보이기
            if (row.updatedAt != null) {
              row.updatedAt = row.updatedAt.substr(0, 16)
            }
          })
        })
        .catch(error => {
          console.log('There was an error:', error.response)
        })
    },
    editItem(item) {
      console.log('editItem');

      // 상품이 등록되어 있는경우
      let bol = false;
      if (this.editedItem.length > 0) {
        for (let i=0; i<this.editedItem.length; i++) {
          if (this.editedItem[i].itemCode == item.itemCode) {
            this.editedItem[i].stockQuantity = item.stockQuantity
            bol = true;
          }
        }
        // 상품이 등록되어 있지 않은 경우
        if (!bol) {
          this.editedItem.push(item);  
        }
      } else {
        // 처음 상품을 등록할 경우
        this.editedItem.push(item);
      }      
    },
    updateStoreStockQuantity() {
      console.log('updateStoreStockQuantity')

      if(this.editedItem.length < 1) {
        alert("基準在庫を更新する商品を選択してください")
        return false;
      }

      let request=[];      
      for (let i=0; i<this.editedItem.length; i++) {

        if (this.editedItem[i].stockQuantity == null) {
          this.editedItem[i].stockQuantity = 0;
        }
        
        let obj = {
          storeCode: this.storeCode,
          itemCode: this.editedItem[i].itemCode,
          stockQuantity: this.editedItem[i].stockQuantity
        }
        
        request.push(obj);
      }

      ServerApiCallService.updateStoreStockQuantity(request)
        .then(response => {
          // 초기화
          this.editedItem = []
          
          ServerApiCallService.getStoreStockQuantity({storeCode: this.storeCode})
        })
        .catch(error => {
          console.log('There was an error:', error.response)
        })
    }
  },
  data() {
    return {
      editedItem: [],
      warehouses: [],
      loading: false,
      dispWarehouseItems: false,
      selectedWarehouse: [],
      search: '',
      storeItems: [],      
      headers: [
        {
          text: 'Category name',
          align: 'left',
          value: 'itemCategoryName',
          width: '15%',
          sortable: false,
          fixed: false,
          class: 'px-2'
        },
        {
          text: this.$t('sales.product-name'),
          align: 'left',
          value: 'itemName',
          width: '20%',
          sortable: false,
          fixed: false,
          class: 'px-2'
        }, 
        {
          text: 'Jan code',
          align: 'center',
          value: 'janCode',
          width: '15%',
          sortable: false,
          fixed: false,
          class: 'px-2'
        },             
        {
          text: this.$t('sales.created-at'),
          align: 'left',
          value: 'createdAt',
          width: '15%',
          sortable: false,
          fixed: false,
          class: 'px-2'
        },
        {
          text: this.$t('sales.updated-at'),
          align: 'left',
          value: 'updatedAt',
          width: '15%',
          sortable: false,
          fixed: false,
          class: 'px-2'
        },
        {
          text: this.$t('sales.stock-quantity'),
          align: 'center',
          value: 'stockQuantity',
          width: '10%',
          sortable: false,
          fixed: false,
          class: 'px-2'
        },
        {
          text: this.$t('sales.standard-stock'),
          align: 'right',
          sortable: false,
          value: 'stocks',
          width: '10%',
          fixed: true,
          class: 'px-2'
        }
      ]
    }
  }
}
</script>

<style>
.confirmed-items {
  background-color: #adadad;
}
#dt tr:nth-child(even) {
  background-color: #f2f2f2;
}
.column-input-for-realtime-stock {
  width: 75px !important;
  height: 40px;
  text-align: right;
  border: 1px solid #c7c7c7;
  padding: 0 4px;
  font-size: 13px;
}
.deleted-class-name {
  background-color: #b3b3b3;
}
tr.changed-class-name,
.theme--light.v-table
  tbody
  tr.changed-class-name:hover:not(.v-datatable__expand-row) {
  background-color: #ffcccc;
}
.out-stock-class-name {
  background-color: #ed2939;
}
</style>
